export enum STAGE_INTERVIEWER_ROTATION {
  MAXIMIZE_AVAILABILITY = 'Maximize Availability',
  EVEN_DISTRIBUTION = 'Even Distribution',
}
